import { useNavigate } from 'react-router-dom';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from '@fluentui/react-components';
import { Building2, FolderPlus, Plus, Rocket } from 'lucide-react';

// The console's one persistent create affordance, in the top bar (FD-481).
//
// It replaces the two CTAs FD-470 portalled into the bar from the Groups page.
// Those were correct for that page and wrong as the only route to creation: an
// operator on Devices, Tenants or a campaign detail had no way to start a new
// campaign without navigating somewhere else first to find the button.
//
// THREE ENTRIES SINCE R-FD-055. The Tenant entry was deliberately absent until
// then, for a reason that was true: there was no create-tenant endpoint, and a
// disabled or "coming soon" entry is exactly the affordance FD-ADR-043 D4 omits
// rather than stubs. POST /v1/tenants (FD-563) retired that reason — the entry now
// opens the Connect page, which is a real operation — so D4 is honoured, not broken
// (FD-ADR-043's R-FD-050 omission, reversed 2026-10-05).
//
// `PageActionsSlot` survives with no caller, and that is on purpose. It is the
// shell's facility for a page's OWN primary action — an export, an assign, an
// operation scoped to what is on screen — which is a different thing from a
// global create. Deleting a tested, documented mechanism because its first
// consumer moved would be removing the mechanism to remove the instance.

interface CreateMenuItem {
  label: string;
  description: string;
  to: string;
  icon: typeof Rocket;
}

const ITEMS: CreateMenuItem[] = [
  {
    label: 'Campaign',
    description: 'Devices moving to one destination',
    to: '/migrations/new',
    icon: Rocket,
  },
  {
    label: 'Group',
    description: 'A container for related campaigns',
    to: '/groups/new',
    icon: FolderPlus,
  },
  {
    label: 'Tenant',
    description: 'Connect a source or destination tenant',
    to: '/tenants/connect',
    icon: Building2,
  },
];

export default function CreateMenu() {
  const navigate = useNavigate();

  return (
    <Menu positioning={{ position: 'below', align: 'end' }}>
      <MenuTrigger disableButtonEnhancement>
        <MenuButton appearance="primary" icon={<Plus size={16} strokeWidth={1.5} />}>
          New
        </MenuButton>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {ITEMS.map((item) => (
            <MenuItem
              key={item.to}
              icon={<item.icon size={16} strokeWidth={1.5} />}
              secondaryContent={item.description}
              onClick={() => navigate(item.to)}
            >
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
